import request from '@/utils/request';
const querystring = require('querystring')

//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comUser/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const fetchUserById = query => {
    var list = request({
        url: 'comUser/getData.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const fetchUserByIdS = query => {
    var list = request({
        url: 'comUser/getListByIds.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//启用-禁用
export const changeStatus = query => {
    var list = request({
        url: 'comUser/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'comUser/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete = query => {
    var list = request({
        url: 'comUser/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDeleteMore = query => {
    var list = request({
        url: 'comUser/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handUpdateMore = query => {
    var list = request({
        url: 'comUser/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const changeForm = query => {
    var list = request({
        url: 'comUser/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {
    var list = request({
        url: 'comUser/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};



